import React, { forwardRef } from 'react';
import { Input } from './Input';

interface SearchInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;
  onClear?: () => void;
  showClearButton?: boolean;
  autoComplete?: string;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  ({ value, onChange, placeholder = "Search...", className = "", onClear, showClearButton = true, autoComplete = "off", onFocus, onBlur }, ref) => {
    return (
      <div className="relative">
        <Input
          ref={ref}
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          className={`${className} ${showClearButton ? 'pr-10' : ''}`}
          autoComplete={autoComplete}
        />
        {showClearButton && value && onClear && (
          <button
            onClick={onClear}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-text-muted hover:text-text-primary transition-colors"
            title="Clear search"
            type="button"
          >
            ✕
          </button>
        )}
      </div>
    );
  }
);

SearchInput.displayName = 'SearchInput';
